export const endPoints = {
    FORM_LEAD_FILTER: '/v1/form-report/filter',
    FORM_LEAD_FILTER_EXCEL: '/v1/form-report/filter/excel',
    GET_FORM_REPORT: 'v1/form-report'
};
